export interface Topic {
  id: string;
  name: string;
  subjectId: string;
  grade: '10' | '11' | '12';
  description: string;
  icon: string;
  lessonCount: number;
  estimatedHours: number;
  difficulty: 'Beginner' | 'Intermediate' | 'Advanced';
  color: string;
  completionPercent: number;
}

export const allTopics: Topic[] = [
  // MATHEMATICS — Grade 10
  {
    id: 'math-10-algebra',
    name: 'Algebra',
    subjectId: 'math',
    grade: '10',
    description: 'Simplify expressions, solve equations, work with exponents and factorisation fundamentals.',
    icon: 'ri-function-line',
    lessonCount: 6,
    estimatedHours: 4.5,
    difficulty: 'Beginner',
    color: '#C0392B',
    completionPercent: 0,
  },
  {
    id: 'math-10-functions',
    name: 'Functions',
    subjectId: 'math',
    grade: '10',
    description: 'Linear, quadratic, and hyperbolic functions — graphs, domains, ranges, and transformations.',
    icon: 'ri-line-chart-line',
    lessonCount: 7,
    estimatedHours: 5.5,
    difficulty: 'Beginner',
    color: '#C0392B',
    completionPercent: 0,
  },
  {
    id: 'math-10-trig',
    name: 'Trigonometry',
    subjectId: 'math',
    grade: '10',
    description: 'Angles, special triangles, sine/cosine/tangent ratios, and solving right triangles.',
    icon: 'ri-triangle-line',
    lessonCount: 5,
    estimatedHours: 4,
    difficulty: 'Beginner',
    color: '#C0392B',
    completionPercent: 0,
  },
  {
    id: 'math-10-geometry',
    name: 'Geometry',
    subjectId: 'math',
    grade: '10',
    description: 'Euclidean geometry basics, congruency, similarity, and properties of polygons.',
    icon: 'ri-shapes-line',
    lessonCount: 6,
    estimatedHours: 4.5,
    difficulty: 'Beginner',
    color: '#C0392B',
    completionPercent: 0,
  },
  {
    id: 'math-10-probability',
    name: 'Probability',
    subjectId: 'math',
    grade: '10',
    description: 'Introduction to probability theory, events, sample spaces, and basic calculations.',
    icon: 'ri-dice-line',
    lessonCount: 4,
    estimatedHours: 3,
    difficulty: 'Beginner',
    color: '#C0392B',
    completionPercent: 0,
  },
  {
    id: 'math-10-statistics',
    name: 'Statistics',
    subjectId: 'math',
    grade: '10',
    description: 'Data collection, measures of central tendency, and basic data representation.',
    icon: 'ri-bar-chart-grouped-line',
    lessonCount: 4,
    estimatedHours: 3,
    difficulty: 'Beginner',
    color: '#C0392B',
    completionPercent: 0,
  },

  // MATHEMATICS — Grade 11
  {
    id: 'math-11-algebra',
    name: 'Advanced Algebra',
    subjectId: 'math',
    grade: '11',
    description: 'Complex number systems, advanced factorisation, and quadratic inequalities.',
    icon: 'ri-function-line',
    lessonCount: 6,
    estimatedHours: 5,
    difficulty: 'Intermediate',
    color: '#C0392B',
    completionPercent: 0,
  },
  {
    id: 'math-11-trig',
    name: 'Advanced Trigonometry',
    subjectId: 'math',
    grade: '11',
    description: 'Sine rule, cosine rule, area of triangles, and reduction formulae.',
    icon: 'ri-triangle-line',
    lessonCount: 7,
    estimatedHours: 6,
    difficulty: 'Intermediate',
    color: '#C0392B',
    completionPercent: 0,
  },
  {
    id: 'math-11-functions',
    name: 'Functions & Graphs',
    subjectId: 'math',
    grade: '11',
    description: 'Logarithmic, exponential, and trigonometric functions with inverse functions.',
    icon: 'ri-line-chart-line',
    lessonCount: 7,
    estimatedHours: 6,
    difficulty: 'Intermediate',
    color: '#C0392B',
    completionPercent: 0,
  },
  {
    id: 'math-11-sequences',
    name: 'Sequences & Series',
    subjectId: 'math',
    grade: '11',
    description: 'Arithmetic and geometric sequences, sigma notation, and financial maths.',
    icon: 'ri-stack-line',
    lessonCount: 5,
    estimatedHours: 4.5,
    difficulty: 'Intermediate',
    color: '#C0392B',
    completionPercent: 0,
  },
  {
    id: 'math-11-analytical',
    name: 'Analytical Geometry',
    subjectId: 'math',
    grade: '11',
    description: 'Distance, midpoint, gradient, and equations of lines in coordinate geometry.',
    icon: 'ri-map-pin-line',
    lessonCount: 5,
    estimatedHours: 4,
    difficulty: 'Intermediate',
    color: '#C0392B',
    completionPercent: 0,
  },

  // MATHEMATICS — Grade 12
  {
    id: 'math-12-calculus',
    name: 'Calculus',
    subjectId: 'math',
    grade: '12',
    description: 'Limits, derivatives, differentiation rules, and applications of differential calculus.',
    icon: 'ri-swap-line',
    lessonCount: 8,
    estimatedHours: 7,
    difficulty: 'Advanced',
    color: '#C0392B',
    completionPercent: 0,
  },
  {
    id: 'math-12-functions',
    name: 'Functions & Inverses',
    subjectId: 'math',
    grade: '12',
    description: 'Advanced function theory, inverse functions, and logarithmic equations.',
    icon: 'ri-line-chart-line',
    lessonCount: 6,
    estimatedHours: 5,
    difficulty: 'Advanced',
    color: '#C0392B',
    completionPercent: 0,
  },
  {
    id: 'math-12-trig',
    name: 'Trigonometric Identities',
    subjectId: 'math',
    grade: '12',
    description: 'Compound angles, double angles, and solving trigonometric equations.',
    icon: 'ri-triangle-line',
    lessonCount: 6,
    estimatedHours: 5,
    difficulty: 'Advanced',
    color: '#C0392B',
    completionPercent: 0,
  },
  {
    id: 'math-12-probability',
    name: 'Probability & Counting',
    subjectId: 'math',
    grade: '12',
    description: 'Counting principles, permutations, combinations, and advanced probability.',
    icon: 'ri-dice-line',
    lessonCount: 5,
    estimatedHours: 4,
    difficulty: 'Advanced',
    color: '#C0392B',
    completionPercent: 0,
  },
  {
    id: 'math-12-statistics',
    name: 'Statistics & Regression',
    subjectId: 'math',
    grade: '12',
    description: 'Scatter plots, least squares regression, and correlation analysis.',
    icon: 'ri-bar-chart-grouped-line',
    lessonCount: 4,
    estimatedHours: 3.5,
    difficulty: 'Advanced',
    color: '#C0392B',
    completionPercent: 0,
  },

  // PHYSICAL SCIENCES — Grade 10
  {
    id: 'phy-10-vectors',
    name: 'Vectors & Scalars',
    subjectId: 'physics',
    grade: '10',
    description: 'Distinguish between vectors and scalars, add vectors graphically and algebraically.',
    icon: 'ri-arrow-up-down-line',
    lessonCount: 4,
    estimatedHours: 3,
    difficulty: 'Beginner',
    color: '#E67E22',
    completionPercent: 0,
  },
  {
    id: 'phy-10-forces',
    name: 'Forces & Newton\'s Laws',
    subjectId: 'physics',
    grade: '10',
    description: 'Types of forces, free-body diagrams, and Newton\'s three laws of motion.',
    icon: 'ri-pushpin-line',
    lessonCount: 6,
    estimatedHours: 4.5,
    difficulty: 'Beginner',
    color: '#E67E22',
    completionPercent: 0,
  },
  {
    id: 'phy-10-electricity',
    name: 'Electricity Basics',
    subjectId: 'physics',
    grade: '10',
    description: 'Electric charge, current, voltage, resistance, and Ohm\'s law.',
    icon: 'ri-flashlight-line',
    lessonCount: 5,
    estimatedHours: 4,
    difficulty: 'Beginner',
    color: '#E67E22',
    completionPercent: 0,
  },
  {
    id: 'phy-10-chem-reactions',
    name: 'Chemical Reactions',
    subjectId: 'physics',
    grade: '10',
    description: 'Types of reactions, balancing equations, and reaction rates.',
    icon: 'ri-flask-line',
    lessonCount: 5,
    estimatedHours: 3.5,
    difficulty: 'Beginner',
    color: '#E67E22',
    completionPercent: 0,
  },
  {
    id: 'phy-10-waves',
    name: 'Waves, Sound & Light',
    subjectId: 'physics',
    grade: '10',
    description: 'Wave properties, sound waves, light refraction, and the electromagnetic spectrum.',
    icon: 'ri-signal-tower-line',
    lessonCount: 5,
    estimatedHours: 4,
    difficulty: 'Beginner',
    color: '#E67E22',
    completionPercent: 0,
  },

  // PHYSICAL SCIENCES — Grade 11
  {
    id: 'phy-11-momentum',
    name: 'Momentum & Impulse',
    subjectId: 'physics',
    grade: '11',
    description: 'Conservation of momentum, impulse, elastic and inelastic collisions.',
    icon: 'ri-speed-line',
    lessonCount: 5,
    estimatedHours: 4,
    difficulty: 'Intermediate',
    color: '#E67E22',
    completionPercent: 0,
  },
  {
    id: 'phy-11-circuits',
    name: 'Electric Circuits',
    subjectId: 'physics',
    grade: '11',
    description: 'Series and parallel circuits, power, energy, and household electricity.',
    icon: 'ri-cpu-line',
    lessonCount: 6,
    estimatedHours: 5,
    difficulty: 'Intermediate',
    color: '#E67E22',
    completionPercent: 0,
  },
  {
    id: 'phy-11-electrostatics',
    name: 'Electrostatics',
    subjectId: 'physics',
    grade: '11',
    description: 'Coulomb\'s law, electric fields, and potential difference.',
    icon: 'ri-thunderstorms-line',
    lessonCount: 5,
    estimatedHours: 4,
    difficulty: 'Intermediate',
    color: '#E67E22',
    completionPercent: 0,
  },
  {
    id: 'phy-11-thermo',
    name: 'Thermodynamics',
    subjectId: 'physics',
    grade: '11',
    description: 'Kinetic theory, gas laws, and the first law of thermodynamics.',
    icon: 'ri-fire-line',
    lessonCount: 4,
    estimatedHours: 3.5,
    difficulty: 'Intermediate',
    color: '#E67E22',
    completionPercent: 0,
  },

  // PHYSICAL SCIENCES — Grade 12
  {
    id: 'phy-12-work-energy',
    name: 'Work, Energy & Power',
    subjectId: 'physics',
    grade: '12',
    description: 'Work-energy theorem, conservation of mechanical energy, and power calculations.',
    icon: 'ri-lightbulb-flash-line',
    lessonCount: 6,
    estimatedHours: 5,
    difficulty: 'Advanced',
    color: '#E67E22',
    completionPercent: 0,
  },
  {
    id: 'phy-12-electromag',
    name: 'Electromagnetism',
    subjectId: 'physics',
    grade: '12',
    description: 'Magnetic fields, Faraday\'s law, generators, motors, and transformers.',
    icon: 'ri-broadcast-line',
    lessonCount: 6,
    estimatedHours: 5.5,
    difficulty: 'Advanced',
    color: '#E67E22',
    completionPercent: 0,
  },
  {
    id: 'phy-12-optics',
    name: 'Geometric Optics',
    subjectId: 'physics',
    grade: '12',
    description: 'Lenses, mirrors, ray diagrams, and the lens formula.',
    icon: 'ri-eye-line',
    lessonCount: 5,
    estimatedHours: 4,
    difficulty: 'Advanced',
    color: '#E67E22',
    completionPercent: 0,
  },
  {
    id: 'phy-12-chem',
    name: 'Physical Chemistry',
    subjectId: 'physics',
    grade: '12',
    description: 'Chemical equilibrium, acids and bases, redox reactions, and electrochemistry.',
    icon: 'ri-flask-line',
    lessonCount: 7,
    estimatedHours: 6,
    difficulty: 'Advanced',
    color: '#E67E22',
    completionPercent: 0,
  },

  // LIFE SCIENCES — Grade 10
  {
    id: 'bio-10-cells',
    name: 'Cells & Cell Division',
    subjectId: 'life-sciences',
    grade: '10',
    description: 'Cell structure, organelles, mitosis, and the cell cycle.',
    icon: 'ri-microscope-line',
    lessonCount: 6,
    estimatedHours: 4.5,
    difficulty: 'Beginner',
    color: '#27AE60',
    completionPercent: 0,
  },
  {
    id: 'bio-10-dna',
    name: 'DNA & Genetics',
    subjectId: 'life-sciences',
    grade: '10',
    description: 'DNA structure, replication, protein synthesis, and Mendelian genetics.',
    icon: 'ri-dna-line',
    lessonCount: 7,
    estimatedHours: 5.5,
    difficulty: 'Beginner',
    color: '#27AE60',
    completionPercent: 0,
  },
  {
    id: 'bio-10-human-body',
    name: 'Human Body Systems',
    subjectId: 'life-sciences',
    grade: '10',
    description: 'The circulatory, respiratory, and digestive systems structure and function.',
    icon: 'ri-heart-pulse-line',
    lessonCount: 6,
    estimatedHours: 5,
    difficulty: 'Beginner',
    color: '#27AE60',
    completionPercent: 0,
  },
  {
    id: 'bio-10-ecology',
    name: 'Ecology & Ecosystems',
    subjectId: 'life-sciences',
    grade: '10',
    description: 'Food chains, biomes, biodiversity, and human impact on ecosystems.',
    icon: 'ri-plant-line',
    lessonCount: 5,
    estimatedHours: 4,
    difficulty: 'Beginner',
    color: '#27AE60',
    completionPercent: 0,
  },

  // LIFE SCIENCES — Grade 11
  {
    id: 'bio-11-evolution',
    name: 'Evolution',
    subjectId: 'life-sciences',
    grade: '11',
    description: 'Natural selection, speciation, evidence for evolution, and human evolution.',
    icon: 'ri-seedling-line',
    lessonCount: 5,
    estimatedHours: 4,
    difficulty: 'Intermediate',
    color: '#27AE60',
    completionPercent: 0,
  },
  {
    id: 'bio-11-genetics',
    name: 'Advanced Genetics',
    subjectId: 'life-sciences',
    grade: '11',
    description: 'Mutations, genetic engineering, biotechnology, and genetic disorders.',
    icon: 'ri-dna-line',
    lessonCount: 5,
    estimatedHours: 4,
    difficulty: 'Intermediate',
    color: '#27AE60',
    completionPercent: 0,
  },
  {
    id: 'bio-11-respiration',
    name: 'Respiration & Photosynthesis',
    subjectId: 'life-sciences',
    grade: '11',
    description: 'Aerobic and anaerobic respiration, photosynthesis, and energy transfer.',
    icon: 'ri-sun-line',
    lessonCount: 5,
    estimatedHours: 4,
    difficulty: 'Intermediate',
    color: '#27AE60',
    completionPercent: 0,
  },
  {
    id: 'bio-11-microbes',
    name: 'Microbiology & Disease',
    subjectId: 'life-sciences',
    grade: '11',
    description: 'Bacteria, viruses, immunity, and disease prevention.',
    icon: 'ri-virus-line',
    lessonCount: 4,
    estimatedHours: 3,
    difficulty: 'Intermediate',
    color: '#27AE60',
    completionPercent: 0,
  },

  // LIFE SCIENCES — Grade 12
  {
    id: 'bio-12-human',
    name: 'Advanced Human Physiology',
    subjectId: 'life-sciences',
    grade: '12',
    description: 'The nervous system, endocrine system, and homeostasis regulation.',
    icon: 'ri-brain-line',
    lessonCount: 6,
    estimatedHours: 5,
    difficulty: 'Advanced',
    color: '#27AE60',
    completionPercent: 0,
  },
  {
    id: 'bio-12-eco',
    name: 'Population & Ecology',
    subjectId: 'life-sciences',
    grade: '12',
    description: 'Population dynamics, community interactions, and conservation biology.',
    icon: 'ri-earth-line',
    lessonCount: 5,
    estimatedHours: 4,
    difficulty: 'Advanced',
    color: '#27AE60',
    completionPercent: 0,
  },
  {
    id: 'bio-12-genetics',
    name: 'Molecular Genetics',
    subjectId: 'life-sciences',
    grade: '12',
    description: 'Gene expression regulation, genetic recombination, and biotechnology ethics.',
    icon: 'ri-dna-line',
    lessonCount: 5,
    estimatedHours: 4,
    difficulty: 'Advanced',
    color: '#27AE60',
    completionPercent: 0,
  },

  // ACCOUNTING — Grade 10
  {
    id: 'acc-10-ledger',
    name: 'Ledger Accounts',
    subjectId: 'accounting',
    grade: '10',
    description: 'Double-entry system, T-accounts, and the accounting equation.',
    icon: 'ri-book-3-line',
    lessonCount: 5,
    estimatedHours: 4,
    difficulty: 'Beginner',
    color: '#8E44AD',
    completionPercent: 0,
  },
  {
    id: 'acc-10-journals',
    name: 'Journals',
    subjectId: 'accounting',
    grade: '10',
    description: 'General journal, cash receipts, cash payments, and special journals.',
    icon: 'ri-article-line',
    lessonCount: 5,
    estimatedHours: 4,
    difficulty: 'Beginner',
    color: '#8E44AD',
    completionPercent: 0,
  },
  {
    id: 'acc-10-statements',
    name: 'Financial Statements',
    subjectId: 'accounting',
    grade: '10',
    description: 'Income statement, balance sheet, and trial balance preparation.',
    icon: 'ri-file-chart-line',
    lessonCount: 5,
    estimatedHours: 4,
    difficulty: 'Beginner',
    color: '#8E44AD',
    completionPercent: 0,
  },
  {
    id: 'acc-10-vat',
    name: 'VAT Basics',
    subjectId: 'accounting',
    grade: '10',
    description: 'Understanding VAT, input/output VAT, and basic VAT calculations.',
    icon: 'ri-calculator-line',
    lessonCount: 3,
    estimatedHours: 2.5,
    difficulty: 'Beginner',
    color: '#8E44AD',
    completionPercent: 0,
  },

  // ACCOUNTING — Grade 11
  {
    id: 'acc-11-cash',
    name: 'Cash Flow',
    subjectId: 'accounting',
    grade: '11',
    description: 'Cash flow statements, operating/investing/financing activities.',
    icon: 'ri-exchange-dollar-line',
    lessonCount: 5,
    estimatedHours: 4,
    difficulty: 'Intermediate',
    color: '#8E44AD',
    completionPercent: 0,
  },
  {
    id: 'acc-11-inventory',
    name: 'Inventory Systems',
    subjectId: 'accounting',
    grade: '11',
    description: 'FIFO, weighted average, perpetual vs periodic inventory systems.',
    icon: 'ri-archive-line',
    lessonCount: 4,
    estimatedHours: 3.5,
    difficulty: 'Intermediate',
    color: '#8E44AD',
    completionPercent: 0,
  },
  {
    id: 'acc-11-depreciation',
    name: 'Depreciation',
    subjectId: 'accounting',
    grade: '11',
    description: 'Straight-line, diminishing balance, and asset disposal calculations.',
    icon: 'ri-arrow-down-circle-line',
    lessonCount: 4,
    estimatedHours: 3.5,
    difficulty: 'Intermediate',
    color: '#8E44AD',
    completionPercent: 0,
  },

  // ACCOUNTING — Grade 12
  {
    id: 'acc-12-closing',
    name: 'Closing Entries',
    subjectId: 'accounting',
    grade: '12',
    description: 'Year-end procedures, closing ledger accounts, and post-closing trial balance.',
    icon: 'ri-lock-line',
    lessonCount: 4,
    estimatedHours: 3.5,
    difficulty: 'Advanced',
    color: '#8E44AD',
    completionPercent: 0,
  },
  {
    id: 'acc-12-analysis',
    name: 'Financial Analysis',
    subjectId: 'accounting',
    grade: '12',
    description: 'Ratio analysis, interpretation of financial statements, and business decisions.',
    icon: 'ri-pie-chart-line',
    lessonCount: 5,
    estimatedHours: 4,
    difficulty: 'Advanced',
    color: '#8E44AD',
    completionPercent: 0,
  },
  {
    id: 'acc-12-budgeting',
    name: 'Budgeting & Forecasting',
    subjectId: 'accounting',
    grade: '12',
    description: 'Cash budgets, production budgets, and variance analysis.',
    icon: 'ri-calendar-check-line',
    lessonCount: 4,
    estimatedHours: 3.5,
    difficulty: 'Advanced',
    color: '#8E44AD',
    completionPercent: 0,
  },

  // CAT — Grade 10
  {
    id: 'cat-10-word',
    name: 'Microsoft Word',
    subjectId: 'cat',
    grade: '10',
    description: 'Document formatting, styles, mail merge, and professional document creation.',
    icon: 'ri-file-text-line',
    lessonCount: 5,
    estimatedHours: 4,
    difficulty: 'Beginner',
    color: '#2980B9',
    completionPercent: 0,
  },
  {
    id: 'cat-10-excel',
    name: 'Microsoft Excel',
    subjectId: 'cat',
    grade: '10',
    description: 'Formulas, functions, formatting, charts, and basic data analysis.',
    icon: 'ri-table-line',
    lessonCount: 6,
    estimatedHours: 4.5,
    difficulty: 'Beginner',
    color: '#2980B9',
    completionPercent: 0,
  },
  {
    id: 'cat-10-ppt',
    name: 'Microsoft PowerPoint',
    subjectId: 'cat',
    grade: '10',
    description: 'Slide design, animations, transitions, and professional presentations.',
    icon: 'ri-slideshow-line',
    lessonCount: 4,
    estimatedHours: 3,
    difficulty: 'Beginner',
    color: '#2980B9',
    completionPercent: 0,
  },
  {
    id: 'cat-10-html',
    name: 'HTML Basics',
    subjectId: 'cat',
    grade: '10',
    description: 'HTML structure, tags, attributes, and creating basic web pages.',
    icon: 'ri-code-box-line',
    lessonCount: 4,
    estimatedHours: 3,
    difficulty: 'Beginner',
    color: '#2980B9',
    completionPercent: 0,
  },

  // CAT — Grade 11
  {
    id: 'cat-11-db',
    name: 'Database Concepts',
    subjectId: 'cat',
    grade: '11',
    description: 'Relational databases, tables, queries, forms, and basic SQL.',
    icon: 'ri-database-2-line',
    lessonCount: 5,
    estimatedHours: 4,
    difficulty: 'Intermediate',
    color: '#2980B9',
    completionPercent: 0,
  },
  {
    id: 'cat-11-file',
    name: 'File Management',
    subjectId: 'cat',
    grade: '11',
    description: 'Folder structures, file naming conventions, backup strategies, and cloud storage.',
    icon: 'ri-folder-3-line',
    lessonCount: 3,
    estimatedHours: 2.5,
    difficulty: 'Intermediate',
    color: '#2980B9',
    completionPercent: 0,
  },
  {
    id: 'cat-11-advanced-excel',
    name: 'Advanced Excel',
    subjectId: 'cat',
    grade: '11',
    description: 'Pivot tables, advanced formulas, conditional formatting, and data validation.',
    icon: 'ri-bar-chart-2-line',
    lessonCount: 5,
    estimatedHours: 4,
    difficulty: 'Intermediate',
    color: '#2980B9',
    completionPercent: 0,
  },

  // CAT — Grade 12
  {
    id: 'cat-12-web',
    name: 'Web Development',
    subjectId: 'cat',
    grade: '12',
    description: 'CSS styling, responsive design, JavaScript basics, and web publishing.',
    icon: 'ri-global-line',
    lessonCount: 5,
    estimatedHours: 4.5,
    difficulty: 'Advanced',
    color: '#2980B9',
    completionPercent: 0,
  },
  {
    id: 'cat-12-project',
    name: 'IT Project Management',
    subjectId: 'cat',
    grade: '12',
    description: 'Project planning, Gantt charts, risk management, and IT project life cycle.',
    icon: 'ri-projector-line',
    lessonCount: 4,
    estimatedHours: 3,
    difficulty: 'Advanced',
    color: '#2980B9',
    completionPercent: 0,
  },
  {
    id: 'cat-12-security',
    name: 'IT Security & Ethics',
    subjectId: 'cat',
    grade: '12',
    description: 'Cybersecurity basics, data protection, intellectual property, and digital citizenship.',
    icon: 'ri-shield-check-line',
    lessonCount: 4,
    estimatedHours: 3,
    difficulty: 'Advanced',
    color: '#2980B9',
    completionPercent: 0,
  },

  // ── GEOGRAPHY — Grade 10 ──────────────────────────────
  { id: 'geo-10-mapwork', name: 'Mapwork', subjectId: 'geography', grade: '10', description: 'Bearings, scales, contour lines, cross-sections, and interpreting topographic maps.', icon: 'ri-map-2-line', lessonCount: 5, estimatedHours: 4, difficulty: 'Beginner', color: '#1E8BC3', completionPercent: 0 },
  { id: 'geo-10-atmosphere', name: 'Atmosphere', subjectId: 'geography', grade: '10', description: 'Structure of the atmosphere, weather elements, climate, and biomes.', icon: 'ri-cloud-line', lessonCount: 5, estimatedHours: 4, difficulty: 'Beginner', color: '#1E8BC3', completionPercent: 0 },
  { id: 'geo-10-geomorphology', name: 'Geomorphology', subjectId: 'geography', grade: '10', description: 'Weathering, mass movement, soil formation, and landform development.', icon: 'ri-landscape-line', lessonCount: 4, estimatedHours: 3.5, difficulty: 'Beginner', color: '#1E8BC3', completionPercent: 0 },
  { id: 'geo-10-settlement', name: 'Settlement Geography', subjectId: 'geography', grade: '10', description: 'Urban and rural settlement patterns, site and situation, urbanisation in SA.', icon: 'ri-building-2-line', lessonCount: 4, estimatedHours: 3, difficulty: 'Beginner', color: '#1E8BC3', completionPercent: 0 },

  // ── GEOGRAPHY — Grade 11 ──────────────────────────────
  { id: 'geo-11-atmosphere', name: 'Atmosphere & Climate', subjectId: 'geography', grade: '11', description: 'Climate regions, air masses, synoptic maps, El Niño, and biomes of the world.', icon: 'ri-cloud-windy-line', lessonCount: 6, estimatedHours: 5, difficulty: 'Intermediate', color: '#1E8BC3', completionPercent: 0 },
  { id: 'geo-11-rivers', name: 'Fluvial Processes & Rivers', subjectId: 'geography', grade: '11', description: 'River erosion, transportation, deposition, drainage patterns, and management.', icon: 'ri-water-flash-line', lessonCount: 5, estimatedHours: 4, difficulty: 'Intermediate', color: '#1E8BC3', completionPercent: 0 },
  { id: 'geo-11-population', name: 'Population Geography', subjectId: 'geography', grade: '11', description: 'Population growth, migration, demographic transition, and SA population issues.', icon: 'ri-group-line', lessonCount: 5, estimatedHours: 4, difficulty: 'Intermediate', color: '#1E8BC3', completionPercent: 0 },
  { id: 'geo-11-economic', name: 'Economic Geography', subjectId: 'geography', grade: '11', description: 'Agriculture, industry, location factors, and economic sectors.', icon: 'ri-store-2-line', lessonCount: 4, estimatedHours: 3.5, difficulty: 'Intermediate', color: '#1E8BC3', completionPercent: 0 },

  // ── GEOGRAPHY — Grade 12 ──────────────────────────────
  { id: 'geo-12-development', name: 'Development Geography', subjectId: 'geography', grade: '12', description: 'Development indicators (HDI, GDP), globalisation, and inequality between countries.', icon: 'ri-global-line', lessonCount: 5, estimatedHours: 4.5, difficulty: 'Advanced', color: '#1E8BC3', completionPercent: 0 },
  { id: 'geo-12-drainage', name: 'Drainage & Slope Development', subjectId: 'geography', grade: '12', description: 'Slope profiles, drainage patterns, catchment areas, and river management.', icon: 'ri-drop-line', lessonCount: 5, estimatedHours: 4, difficulty: 'Advanced', color: '#1E8BC3', completionPercent: 0 },
  { id: 'geo-12-climate-change', name: 'Climate Change', subjectId: 'geography', grade: '12', description: 'Causes, evidence, and consequences of climate change — impacts on SA and the world.', icon: 'ri-temp-hot-line', lessonCount: 4, estimatedHours: 3.5, difficulty: 'Advanced', color: '#1E8BC3', completionPercent: 0 },
  { id: 'geo-12-resources', name: 'Resources & Economic Geography', subjectId: 'geography', grade: '12', description: 'Global resource distribution, energy, sustainability, and economic globalisation.', icon: 'ri-oil-line', lessonCount: 4, estimatedHours: 3.5, difficulty: 'Advanced', color: '#1E8BC3', completionPercent: 0 },

  // ── HISTORY — Grade 10 ───────────────────────────────
  { id: 'hist-10-colonialism', name: 'Colonialism & Imperialism', subjectId: 'history', grade: '10', description: 'European colonialism, imperialism in Africa and Asia, and the Scramble for Africa.', icon: 'ri-flag-line', lessonCount: 5, estimatedHours: 4, difficulty: 'Beginner', color: '#7D3C98', completionPercent: 0 },
  { id: 'hist-10-industrial', name: 'Industrial Revolution', subjectId: 'history', grade: '10', description: 'Origins of industrialisation, impact on society, labour movements, and capitalism.', icon: 'ri-settings-3-line', lessonCount: 4, estimatedHours: 3.5, difficulty: 'Beginner', color: '#7D3C98', completionPercent: 0 },
  { id: 'hist-10-nationalism', name: 'Nationalism & Nation States', subjectId: 'history', grade: '10', description: 'Rise of nationalism in Europe, unification of Germany and Italy, and their impact.', icon: 'ri-community-line', lessonCount: 4, estimatedHours: 3, difficulty: 'Beginner', color: '#7D3C98', completionPercent: 0 },
  { id: 'hist-10-apartheid-origins', name: 'Segregation in SA', subjectId: 'history', grade: '10', description: 'Origins of racial segregation in SA, Union of 1910, and the rise of Afrikaner nationalism.', icon: 'ri-history-line', lessonCount: 4, estimatedHours: 3.5, difficulty: 'Beginner', color: '#7D3C98', completionPercent: 0 },

  // ── HISTORY — Grade 11 ───────────────────────────────
  { id: 'hist-11-ww1', name: 'World War 1', subjectId: 'history', grade: '11', description: 'Causes of WW1, alliances, trench warfare, key battles, and consequences of the war.', icon: 'ri-sword-line', lessonCount: 6, estimatedHours: 5, difficulty: 'Intermediate', color: '#7D3C98', completionPercent: 0 },
  { id: 'hist-11-russian-revolution', name: 'Russian Revolution', subjectId: 'history', grade: '11', description: 'Causes of the revolution, Bolsheviks, civil war, and the rise of the Soviet Union.', icon: 'ri-government-line', lessonCount: 5, estimatedHours: 4, difficulty: 'Intermediate', color: '#7D3C98', completionPercent: 0 },
  { id: 'hist-11-cold-war', name: 'Cold War Origins', subjectId: 'history', grade: '11', description: 'Post-WW2 tensions, division of Europe, NATO vs Warsaw Pact, and proxy wars.', icon: 'ri-radar-line', lessonCount: 5, estimatedHours: 4, difficulty: 'Intermediate', color: '#7D3C98', completionPercent: 0 },
  { id: 'hist-11-apartheid', name: 'Apartheid in SA', subjectId: 'history', grade: '11', description: 'Implementation of apartheid, resistance movements, Sharpeville, and Bantustan policies.', icon: 'ri-scales-line', lessonCount: 5, estimatedHours: 4.5, difficulty: 'Intermediate', color: '#7D3C98', completionPercent: 0 },

  // ── HISTORY — Grade 12 ───────────────────────────────
  { id: 'hist-12-cold-war', name: 'The Cold War (1945–1991)', subjectId: 'history', grade: '12', description: 'Superpower rivalry, arms race, proxy conflicts, détente, and collapse of the Soviet Union.', icon: 'ri-global-line', lessonCount: 6, estimatedHours: 5, difficulty: 'Advanced', color: '#7D3C98', completionPercent: 0 },
  { id: 'hist-12-civil-society', name: 'Civil Society Protest', subjectId: 'history', grade: '12', description: 'Mass protest movements worldwide in the 1950s–80s — civil rights, anti-apartheid, feminism.', icon: 'ri-megaphone-line', lessonCount: 5, estimatedHours: 4, difficulty: 'Advanced', color: '#7D3C98', completionPercent: 0 },
  { id: 'hist-12-decolonisation', name: 'Decolonisation & Nationalisms', subjectId: 'history', grade: '12', description: 'African and Asian independence movements, nationalist leaders, and post-colonial challenges.', icon: 'ri-earth-line', lessonCount: 5, estimatedHours: 4, difficulty: 'Advanced', color: '#7D3C98', completionPercent: 0 },
  { id: 'hist-12-democracy', name: 'SA\'s Road to Democracy', subjectId: 'history', grade: '12', description: 'CODESA negotiations, 1994 elections, Truth and Reconciliation Commission, and the new SA.', icon: 'ri-award-line', lessonCount: 5, estimatedHours: 4.5, difficulty: 'Advanced', color: '#7D3C98', completionPercent: 0 },

  // ── BUSINESS STUDIES — Grade 10 ──────────────────────
  { id: 'bus-10-environments', name: 'Business Environments', subjectId: 'business-studies', grade: '10', description: 'Micro, market, and macro environments — PESTLE analysis and how they affect businesses.', icon: 'ri-building-line', lessonCount: 5, estimatedHours: 4, difficulty: 'Beginner', color: '#1F618D', completionPercent: 0 },
  { id: 'bus-10-ownership', name: 'Forms of Ownership', subjectId: 'business-studies', grade: '10', description: 'Sole trader, partnership, close corporation, private company — advantages and disadvantages.', icon: 'ri-user-star-line', lessonCount: 5, estimatedHours: 3.5, difficulty: 'Beginner', color: '#1F618D', completionPercent: 0 },
  { id: 'bus-10-functions', name: 'Business Functions', subjectId: 'business-studies', grade: '10', description: 'General management, HR, marketing, operations, finance, and purchasing functions.', icon: 'ri-git-branch-line', lessonCount: 4, estimatedHours: 3, difficulty: 'Beginner', color: '#1F618D', completionPercent: 0 },
  { id: 'bus-10-creative', name: 'Creative Thinking & Problem Solving', subjectId: 'business-studies', grade: '10', description: 'Brainstorming, SWOT analysis, decision-making processes, and innovation in business.', icon: 'ri-lightbulb-line', lessonCount: 4, estimatedHours: 3, difficulty: 'Beginner', color: '#1F618D', completionPercent: 0 },

  // ── BUSINESS STUDIES — Grade 11 ──────────────────────
  { id: 'bus-11-ventures', name: 'Business Ventures', subjectId: 'business-studies', grade: '11', description: 'Evaluating business opportunities, feasibility studies, and starting a new business.', icon: 'ri-rocket-line', lessonCount: 5, estimatedHours: 4, difficulty: 'Intermediate', color: '#1F618D', completionPercent: 0 },
  { id: 'bus-11-hr', name: 'Human Resources Management', subjectId: 'business-studies', grade: '11', description: 'Recruitment, selection, training, labour legislation, and worker rights in SA.', icon: 'ri-team-line', lessonCount: 5, estimatedHours: 4, difficulty: 'Intermediate', color: '#1F618D', completionPercent: 0 },
  { id: 'bus-11-marketing', name: 'Marketing', subjectId: 'business-studies', grade: '11', description: 'The 4Ps of marketing, market research, target markets, and marketing strategies.', icon: 'ri-megaphone-line', lessonCount: 5, estimatedHours: 4, difficulty: 'Intermediate', color: '#1F618D', completionPercent: 0 },
  { id: 'bus-11-finance', name: 'Financial Management', subjectId: 'business-studies', grade: '11', description: 'Cash flow forecasts, budgets, break-even analysis, and basic financial statements.', icon: 'ri-money-dollar-circle-line', lessonCount: 5, estimatedHours: 4.5, difficulty: 'Intermediate', color: '#1F618D', completionPercent: 0 },

  // ── BUSINESS STUDIES — Grade 12 ──────────────────────
  { id: 'bus-12-strategies', name: 'Business Strategies', subjectId: 'business-studies', grade: '12', description: 'Competitive advantage, Porter\'s Five Forces, business growth, and strategic planning.', icon: 'ri-chess-line', lessonCount: 5, estimatedHours: 4.5, difficulty: 'Advanced', color: '#1F618D', completionPercent: 0 },
  { id: 'bus-12-investment', name: 'Investment & Growth', subjectId: 'business-studies', grade: '12', description: 'JSE, shares, bonds, financial instruments, and growing a business sustainably.', icon: 'ri-stock-line', lessonCount: 5, estimatedHours: 4, difficulty: 'Advanced', color: '#1F618D', completionPercent: 0 },
  { id: 'bus-12-governance', name: 'Corporate Governance', subjectId: 'business-studies', grade: '12', description: 'Ethics, King Code, legislation (BCEA, LRA, OHSA), and social responsibility.', icon: 'ri-shield-star-line', lessonCount: 4, estimatedHours: 3.5, difficulty: 'Advanced', color: '#1F618D', completionPercent: 0 },
  { id: 'bus-12-entrepreneurship', name: 'Entrepreneurship', subjectId: 'business-studies', grade: '12', description: 'Entrepreneurial qualities, social entrepreneurship, and the role of SMMEs in SA\'s economy.', icon: 'ri-user-heart-line', lessonCount: 4, estimatedHours: 3.5, difficulty: 'Advanced', color: '#1F618D', completionPercent: 0 },

  // ── ECONOMICS — Grade 10 ─────────────────────────────
  { id: 'econ-10-intro', name: 'Introduction to Economics', subjectId: 'economics', grade: '10', description: 'Basic economic concepts — scarcity, opportunity cost, needs vs wants, and economic agents.', icon: 'ri-coins-line', lessonCount: 4, estimatedHours: 3, difficulty: 'Beginner', color: '#D68910', completionPercent: 0 },
  { id: 'econ-10-circular', name: 'Circular Flow Model', subjectId: 'economics', grade: '10', description: 'How households, firms, government, and foreign sectors interact in the economy.', icon: 'ri-refresh-line', lessonCount: 4, estimatedHours: 3, difficulty: 'Beginner', color: '#D68910', completionPercent: 0 },
  { id: 'econ-10-demand-supply', name: 'Demand & Supply', subjectId: 'economics', grade: '10', description: 'Law of demand and supply, demand and supply curves, shifts, and market equilibrium.', icon: 'ri-arrow-up-down-line', lessonCount: 5, estimatedHours: 4, difficulty: 'Beginner', color: '#D68910', completionPercent: 0 },
  { id: 'econ-10-systems', name: 'Economic Systems', subjectId: 'economics', grade: '10', description: 'Market economy, command economy, mixed economy — features, advantages, and disadvantages.', icon: 'ri-government-line', lessonCount: 4, estimatedHours: 3, difficulty: 'Beginner', color: '#D68910', completionPercent: 0 },

  // ── ECONOMICS — Grade 11 ─────────────────────────────
  { id: 'econ-11-elasticity', name: 'Elasticity', subjectId: 'economics', grade: '11', description: 'Price elasticity of demand and supply — calculations, factors, and real-world applications.', icon: 'ri-percent-line', lessonCount: 5, estimatedHours: 4, difficulty: 'Intermediate', color: '#D68910', completionPercent: 0 },
  { id: 'econ-11-business-cycles', name: 'Business Cycles', subjectId: 'economics', grade: '11', description: 'Phases of the business cycle, leading/lagging indicators, and stabilisation policies.', icon: 'ri-line-chart-line', lessonCount: 5, estimatedHours: 4, difficulty: 'Intermediate', color: '#D68910', completionPercent: 0 },
  { id: 'econ-11-public-sector', name: 'The Public Sector', subjectId: 'economics', grade: '11', description: 'Government spending, taxation, fiscal policy, and the role of the state in SA.', icon: 'ri-bank-line', lessonCount: 4, estimatedHours: 3.5, difficulty: 'Intermediate', color: '#D68910', completionPercent: 0 },
  { id: 'econ-11-trade', name: 'International Trade', subjectId: 'economics', grade: '11', description: 'Absolute and comparative advantage, balance of payments, tariffs, and exchange rates.', icon: 'ri-ship-line', lessonCount: 5, estimatedHours: 4, difficulty: 'Intermediate', color: '#D68910', completionPercent: 0 },

  // ── ECONOMICS — Grade 12 ─────────────────────────────
  { id: 'econ-12-growth', name: 'Economic Growth & Development', subjectId: 'economics', grade: '12', description: 'GDP, GNP, HDI — measuring growth and development, and SA\'s economic challenges.', icon: 'ri-bar-chart-grouped-line', lessonCount: 5, estimatedHours: 4.5, difficulty: 'Advanced', color: '#D68910', completionPercent: 0 },
  { id: 'econ-12-globalisation', name: 'Globalisation & International Orgs', subjectId: 'economics', grade: '12', description: 'WTO, IMF, World Bank, globalisation effects, and SA in the global economy.', icon: 'ri-global-line', lessonCount: 5, estimatedHours: 4, difficulty: 'Advanced', color: '#D68910', completionPercent: 0 },
  { id: 'econ-12-labour', name: 'Labour Markets', subjectId: 'economics', grade: '12', description: 'Supply and demand for labour, wage determination, unemployment types, and SA labour issues.', icon: 'ri-user-search-line', lessonCount: 5, estimatedHours: 4, difficulty: 'Advanced', color: '#D68910', completionPercent: 0 },
  { id: 'econ-12-monetary', name: 'Monetary Policy & Inflation', subjectId: 'economics', grade: '12', description: 'SARB, repo rate, inflation targeting, money supply, and the effect on the economy.', icon: 'ri-money-dollar-circle-line', lessonCount: 5, estimatedHours: 4.5, difficulty: 'Advanced', color: '#D68910', completionPercent: 0 },

  // ── MATHEMATICAL LITERACY — Grade 10 ─────────────────
  { id: 'mlit-10-numbers', name: 'Numbers & Operations', subjectId: 'maths-literacy', grade: '10', description: 'Rounding, percentages, ratios, rates, and working with numbers in everyday context.', icon: 'ri-hashtag', lessonCount: 4, estimatedHours: 3, difficulty: 'Beginner', color: '#148F77', completionPercent: 0 },
  { id: 'mlit-10-patterns', name: 'Patterns & Relationships', subjectId: 'maths-literacy', grade: '10', description: 'Number patterns, tables, graphs, and algebraic relationships in real-life situations.', icon: 'ri-table-line', lessonCount: 4, estimatedHours: 3.5, difficulty: 'Beginner', color: '#148F77', completionPercent: 0 },
  { id: 'mlit-10-measurement', name: 'Measurement', subjectId: 'maths-literacy', grade: '10', description: 'Perimeter, area, volume, and surface area — practical measurement in context.', icon: 'ri-ruler-line', lessonCount: 4, estimatedHours: 3, difficulty: 'Beginner', color: '#148F77', completionPercent: 0 },
  { id: 'mlit-10-data', name: 'Data Handling & Probability', subjectId: 'maths-literacy', grade: '10', description: 'Reading graphs, averages, range, and basic probability in everyday life.', icon: 'ri-bar-chart-line', lessonCount: 4, estimatedHours: 3, difficulty: 'Beginner', color: '#148F77', completionPercent: 0 },

  // ── MATHEMATICAL LITERACY — Grade 11 ─────────────────
  { id: 'mlit-11-finance', name: 'Personal Finance', subjectId: 'maths-literacy', grade: '11', description: 'Income tax, VAT, banking, budgeting, and managing personal finances.', icon: 'ri-wallet-3-line', lessonCount: 5, estimatedHours: 4.5, difficulty: 'Intermediate', color: '#148F77', completionPercent: 0 },
  { id: 'mlit-11-measurement', name: 'Measurement in Context', subjectId: 'maths-literacy', grade: '11', description: 'Complex area, surface area, volume, capacity, and converting between units.', icon: 'ri-flask-line', lessonCount: 5, estimatedHours: 4, difficulty: 'Intermediate', color: '#148F77', completionPercent: 0 },
  { id: 'mlit-11-maps', name: 'Maps, Plans & Scale Drawings', subjectId: 'maths-literacy', grade: '11', description: 'Reading maps, floor plans, scale drawings, and calculating actual distances.', icon: 'ri-map-line', lessonCount: 4, estimatedHours: 3.5, difficulty: 'Intermediate', color: '#148F77', completionPercent: 0 },
  { id: 'mlit-11-data', name: 'Data Handling & Statistics', subjectId: 'maths-literacy', grade: '11', description: 'Collecting, organising, and interpreting data — box-and-whisker plots, histograms.', icon: 'ri-pie-chart-line', lessonCount: 4, estimatedHours: 3.5, difficulty: 'Intermediate', color: '#148F77', completionPercent: 0 },

  // ── MATHEMATICAL LITERACY — Grade 12 ─────────────────
  { id: 'mlit-12-finance', name: 'Advanced Finance', subjectId: 'maths-literacy', grade: '12', description: 'Compound interest, hire purchase, loans, investments, and insurance in context.', icon: 'ri-bank-card-line', lessonCount: 5, estimatedHours: 5, difficulty: 'Advanced', color: '#148F77', completionPercent: 0 },
  { id: 'mlit-12-measurement', name: 'Measurement & Geometry', subjectId: 'maths-literacy', grade: '12', description: 'Complex shapes, composite figures, capacity, and practical geometry problems.', icon: 'ri-shapes-line', lessonCount: 5, estimatedHours: 4, difficulty: 'Advanced', color: '#148F77', completionPercent: 0 },
  { id: 'mlit-12-probability', name: 'Probability & Risk', subjectId: 'maths-literacy', grade: '12', description: 'Probability in context, tree diagrams, risk assessment, and everyday decision-making.', icon: 'ri-dice-line', lessonCount: 4, estimatedHours: 3.5, difficulty: 'Advanced', color: '#148F77', completionPercent: 0 },
  { id: 'mlit-12-exam-prep', name: 'Exam Preparation', subjectId: 'maths-literacy', grade: '12', description: 'Past paper practice, common errors, time management, and exam technique for Maths Lit.', icon: 'ri-file-list-3-line', lessonCount: 4, estimatedHours: 3, difficulty: 'Advanced', color: '#148F77', completionPercent: 0 },

  // ── ENGLISH HOME LANGUAGE — Grade 10 ─────────────────
  { id: 'eng-10-reading', name: 'Reading & Comprehension', subjectId: 'english', grade: '10', description: 'Analysing unseen texts, summarising, identifying main ideas, and answering comprehension questions.', icon: 'ri-file-text-line', lessonCount: 5, estimatedHours: 4, difficulty: 'Beginner', color: '#424949', completionPercent: 0 },
  { id: 'eng-10-writing', name: 'Writing & Presenting', subjectId: 'english', grade: '10', description: 'Essays, formal letters, reports, and transactional writing — planning and drafting.', icon: 'ri-edit-line', lessonCount: 5, estimatedHours: 4, difficulty: 'Beginner', color: '#424949', completionPercent: 0 },
  { id: 'eng-10-grammar', name: 'Language Structures & Grammar', subjectId: 'english', grade: '10', description: 'Parts of speech, sentence construction, punctuation, vocabulary, and figurative language.', icon: 'ri-font-size', lessonCount: 4, estimatedHours: 3, difficulty: 'Beginner', color: '#424949', completionPercent: 0 },
  { id: 'eng-10-literature', name: 'Literature', subjectId: 'english', grade: '10', description: 'Prescribed novel, poetry, and drama — themes, characters, literary devices, and analysis.', icon: 'ri-book-2-line', lessonCount: 5, estimatedHours: 4.5, difficulty: 'Beginner', color: '#424949', completionPercent: 0 },

  // ── ENGLISH HOME LANGUAGE — Grade 11 ─────────────────
  { id: 'eng-11-comprehension', name: 'Comprehension & Summary', subjectId: 'english', grade: '11', description: 'Unseen texts, visual texts, summary writing, and identifying author\'s purpose and tone.', icon: 'ri-search-eye-line', lessonCount: 5, estimatedHours: 4, difficulty: 'Intermediate', color: '#424949', completionPercent: 0 },
  { id: 'eng-11-writing', name: 'Written & Transactional Texts', subjectId: 'english', grade: '11', description: 'Argumentative essays, reviews, formal letters, advertisements, and speeches.', icon: 'ri-quill-pen-line', lessonCount: 5, estimatedHours: 4, difficulty: 'Intermediate', color: '#424949', completionPercent: 0 },
  { id: 'eng-11-language', name: 'Language in Context', subjectId: 'english', grade: '11', description: 'Register, tone, style, vocabulary in use, and language for specific purposes.', icon: 'ri-translate-2', lessonCount: 4, estimatedHours: 3.5, difficulty: 'Intermediate', color: '#424949', completionPercent: 0 },
  { id: 'eng-11-literature', name: 'Literature Studies', subjectId: 'english', grade: '11', description: 'Prescribed texts — thematic analysis, character study, literary devices, and essay writing.', icon: 'ri-book-open-line', lessonCount: 5, estimatedHours: 4.5, difficulty: 'Intermediate', color: '#424949', completionPercent: 0 },

  // ── ENGLISH HOME LANGUAGE — Grade 12 ─────────────────
  { id: 'eng-12-language', name: 'Language & Comprehension', subjectId: 'english', grade: '12', description: 'Advanced comprehension, visual texts, cartoons, and extended reading strategies.', icon: 'ri-file-search-line', lessonCount: 5, estimatedHours: 4, difficulty: 'Advanced', color: '#424949', completionPercent: 0 },
  { id: 'eng-12-writing', name: 'Essays & Creative Writing', subjectId: 'english', grade: '12', description: 'Narrative, descriptive, argumentative, and discursive essays — structure and technique.', icon: 'ri-edit-2-line', lessonCount: 5, estimatedHours: 4.5, difficulty: 'Advanced', color: '#424949', completionPercent: 0 },
  { id: 'eng-12-literature', name: 'Literary Analysis', subjectId: 'english', grade: '12', description: 'Poetry, prose, and drama — detailed literary analysis, contextual questions, and essay responses.', icon: 'ri-bookmark-3-line', lessonCount: 5, estimatedHours: 5, difficulty: 'Advanced', color: '#424949', completionPercent: 0 },
  { id: 'eng-12-exam', name: 'Exam Preparation', subjectId: 'english', grade: '12', description: 'Paper 1 and Paper 2 practice — time management, exam technique, and common errors.', icon: 'ri-clipboard-line', lessonCount: 4, estimatedHours: 3.5, difficulty: 'Advanced', color: '#424949', completionPercent: 0 },

  // ── AGRICULTURAL SCIENCES — Grade 10 ─────────────────
  { id: 'agri-10-soil', name: 'Soil Science', subjectId: 'agri-sciences', grade: '10', description: 'Soil composition, properties, soil horizons, and how soils support plant growth.', icon: 'ri-seedling-line', lessonCount: 4, estimatedHours: 3.5, difficulty: 'Beginner', color: '#1D6A39', completionPercent: 0 },
  { id: 'agri-10-plant', name: 'Plant Production', subjectId: 'agri-sciences', grade: '10', description: 'Plant nutrition, photosynthesis, crop planting, and basic farming practices.', icon: 'ri-plant-line', lessonCount: 5, estimatedHours: 4, difficulty: 'Beginner', color: '#1D6A39', completionPercent: 0 },
  { id: 'agri-10-animal', name: 'Animal Production', subjectId: 'agri-sciences', grade: '10', description: 'Types of livestock, animal nutrition, housing, health, and basic animal husbandry.', icon: 'ri-heart-pulse-line', lessonCount: 4, estimatedHours: 3.5, difficulty: 'Beginner', color: '#1D6A39', completionPercent: 0 },
  { id: 'agri-10-agribusiness', name: 'Agribusiness Basics', subjectId: 'agri-sciences', grade: '10', description: 'Agricultural sectors in SA, farming as a business, and basic farm management.', icon: 'ri-store-line', lessonCount: 3, estimatedHours: 2.5, difficulty: 'Beginner', color: '#1D6A39', completionPercent: 0 },

  // ── AGRICULTURAL SCIENCES — Grade 11 ─────────────────
  { id: 'agri-11-soil', name: 'Soil Fertility & Management', subjectId: 'agri-sciences', grade: '11', description: 'Soil pH, fertilisers, irrigation, soil conservation, and erosion prevention.', icon: 'ri-water-flash-line', lessonCount: 5, estimatedHours: 4, difficulty: 'Intermediate', color: '#1D6A39', completionPercent: 0 },
  { id: 'agri-11-crop', name: 'Crop Production & Protection', subjectId: 'agri-sciences', grade: '11', description: 'Crop rotation, pest control, diseases, pesticides, and integrated pest management.', icon: 'ri-bug-line', lessonCount: 5, estimatedHours: 4, difficulty: 'Intermediate', color: '#1D6A39', completionPercent: 0 },
  { id: 'agri-11-animal', name: 'Animal Health & Breeding', subjectId: 'agri-sciences', grade: '11', description: 'Common livestock diseases, vaccination, genetics, selective breeding, and reproduction.', icon: 'ri-dna-line', lessonCount: 4, estimatedHours: 3.5, difficulty: 'Intermediate', color: '#1D6A39', completionPercent: 0 },
  { id: 'agri-11-management', name: 'Farm Management', subjectId: 'agri-sciences', grade: '11', description: 'Farm planning, record keeping, budgets, marketing of produce, and farm legislation in SA.', icon: 'ri-file-list-line', lessonCount: 4, estimatedHours: 3.5, difficulty: 'Intermediate', color: '#1D6A39', completionPercent: 0 },

  // ── AGRICULTURAL SCIENCES — Grade 12 ─────────────────
  { id: 'agri-12-soil', name: 'Advanced Soil & Irrigation', subjectId: 'agri-sciences', grade: '12', description: 'Soil water relationships, irrigation systems, scheduling, and water quality for agriculture.', icon: 'ri-droplet-line', lessonCount: 5, estimatedHours: 4, difficulty: 'Advanced', color: '#1D6A39', completionPercent: 0 },
  { id: 'agri-12-production', name: 'Commercial Crop & Animal Production', subjectId: 'agri-sciences', grade: '12', description: 'Large-scale crop and livestock production — economics, technology, and sustainability.', icon: 'ri-tractor-line', lessonCount: 5, estimatedHours: 4.5, difficulty: 'Advanced', color: '#1D6A39', completionPercent: 0 },
  { id: 'agri-12-agribusiness', name: 'Agribusiness & Entrepreneurship', subjectId: 'agri-sciences', grade: '12', description: 'Agricultural marketing, co-operatives, value chains, and starting an agribusiness in SA.', icon: 'ri-briefcase-line', lessonCount: 4, estimatedHours: 3.5, difficulty: 'Advanced', color: '#1D6A39', completionPercent: 0 },
  { id: 'agri-12-environment', name: 'Environmental Impact of Agriculture', subjectId: 'agri-sciences', grade: '12', description: 'Climate change impacts, sustainable farming, biodiversity, and land degradation.', icon: 'ri-leaf-line', lessonCount: 4, estimatedHours: 3.5, difficulty: 'Advanced', color: '#1D6A39', completionPercent: 0 },
];

export function getTopicsBySubjectAndGrade(subjectId: string, grade: '10' | '11' | '12') {
  return allTopics.filter((t) => t.subjectId === subjectId && t.grade === grade);
}

export function getTopicsBySubject(subjectId: string) {
  return allTopics.filter((t) => t.subjectId === subjectId);
}

export function getTopicById(id: string) {
  return allTopics.find((t) => t.id === id);
}

export function getAllGradesForSubject(subjectId: string) {
  const grades = new Set<string>();
  allTopics.filter((t) => t.subjectId === subjectId).forEach((t) => grades.add(t.grade));
  return Array.from(grades).sort() as ('10' | '11' | '12')[];
}